import moment from 'moment-timezone';
import { mixpanelEvents, mixpanelTrack } from 'utils/mixpanelHelpers';
const {
  newEmployeeDashboard: { CLICK_DASHBOARD_CARD },
} = mixpanelEvents;

export const getDateDay = ({ scheduledDate, formattedDate }) => {
  const today = moment();
  const tomorrow = moment().add(1, 'day');

  if (moment(scheduledDate).isSame(today, 'day')) return 'Today';
  if (moment(scheduledDate).isSame(tomorrow, 'day')) return 'Tomorrow';

  return formattedDate.split('|')[0];
};

export const isWithin45MinAfterStart = (scheduledDate) => {
  // add the window of 45 minutes to scheduled date time
  const past45Minutes = moment(scheduledDate);

  past45Minutes.set({ minute: moment(scheduledDate).minutes() + 45 });

  const now = new Date();

  return (
    !scheduledDate ||
    (moment(now).isAfter(moment(scheduledDate)) &&
      moment(now).isBefore(past45Minutes))
  );
};

export const getPrimaryButtonProps = (upcomingWebinar) => {
  const webinarLink = `/webinars/${upcomingWebinar.encodedId}`;
  const isHappeningNow = isWithin45MinAfterStart(upcomingWebinar.scheduledDate);
  const text = isHappeningNow ? 'Join Now' : 'View Details';

  return {
    text: text,
    link: `${webinarLink}`,
    onClick: () => {
      mixpanelTrack(CLICK_DASHBOARD_CARD, {
        cardType: 'Webinar',
        cardTitle: upcomingWebinar.name,
      });
    },
  };
};
